import React from "react";
import { Button, Select, Tooltip } from "antd";
import { copyToClipboard, handleDownloadCSV } from "../../utils";
import KeywordGroupsToolbar from "../KeywordGroupsToolbar";
import { KeywordGroupWithMembers } from "../keywords/keywords-interfaces";

interface CustomSelectImportantColumnsProps {
    value: string[] | undefined;
    allOptions: { label: string; value: string }[];
    searchValue: string;
    setSearchValue: React.Dispatch<React.SetStateAction<string>>;
    placeholder?: string;
    onChange: (selectedValues: string[]) => void;
    keywordGroups?: KeywordGroupWithMembers[];
}

export default function CustomSelectImportantColumns(props: CustomSelectImportantColumnsProps) {
    const filteredOptions = props.allOptions.filter(option =>
        option.label.toLowerCase().includes(props.searchValue.toLowerCase())
    );
    return (
        <Select
            autoClearSearchValue={false}
            allowClear
            placeholder={props.placeholder || ''}
            mode='multiple'
            style={{ minWidth: '200px' }}
            value={props.value || []}
            filterOption={false}
            onSearch={props.setSearchValue}
            options={filteredOptions}
            onChange={(selectedValues) => {
                props.onChange(selectedValues)
            }}
            onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
            }}
            maxTagCount={10}
            popupRender={(menu) => {
                const isAllSelected = props.value && props.allOptions.length === props.value.length;
                const selectedCount = props.value ? props.value.length : 0;

                return (
                    <div>
                        <div style={{ padding: '8px', borderBottom: '1px solid #f0f0f0' }}>
                            <div style={{ marginBottom: '4px', fontSize: '12px', color: '#666' }}>
                                {selectedCount} / {props.allOptions.length} sélectionnés
                            </div>
                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                <Button
                                    size="small"
                                    type="link"
                                    onClick={() => {
                                        if (isAllSelected) {
                                            props.onChange([]);
                                        } else {
                                            const allOptionsAsString = props.allOptions.map(option => option.value as string);
                                            const resultOptions = []
                                            if (filteredOptions.length === allOptionsAsString.length) {
                                                resultOptions.push(...allOptionsAsString)
                                            } else {
                                                const existingOptions = props.value || []
                                                resultOptions.push(...existingOptions.concat(
                                                    filteredOptions.map(option => option.value as string)
                                                ))
                                            }
                                            props.onChange(Array.from(new Set(resultOptions)));
                                        }
                                        props.setSearchValue('')
                                    }}
                                    style={{ padding: 0 }}
                                >
                                    {isAllSelected ?
                                        "Désélectionner tout" :
                                        filteredOptions.length === props.allOptions.length ? "Tout sélectionner" : `Sélectionner les résultats filtrés (${filteredOptions.length})`
                                    }
                                </Button>
                                {selectedCount > 10 && (
                                    <>
                                        <Tooltip title="Copier les éléments sélectionnés dans le presse-papiers">
                                            <Button
                                                size="small"
                                                type="link"
                                                onClick={() => {
                                                    const textToCopy = props.value?.join("\n") || '';
                                                    copyToClipboard(textToCopy);
                                                }}
                                                style={{ padding: 0 }}
                                                icon={<i className="fa fa-copy" />}
                                            >
                                                Copier
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Télécharger les éléments sélectionnés au format CSV">
                                            <Button
                                                size="small"
                                                type="link"
                                                onClick={() => {
                                                    const text = props.value?.join("\n") || '';
                                                    const filename = `selection.csv`;
                                                    handleDownloadCSV(text, filename);
                                                }}
                                                style={{ padding: 0 }}
                                                icon={<i className="fa fa-download" />}
                                            >
                                                Télécharger
                                            </Button>
                                        </Tooltip>
                                    </>
                                )}
                            </div>
                        </div>
                        {props.keywordGroups && props.keywordGroups.length > 0 && (
                            <KeywordGroupsToolbar
                                groups={props.keywordGroups}
                                selectedKeywords={props.value || []}
                                onSelectedKeywordsChange={props.onChange}
                            />
                        )}
                        {menu}
                    </div >
                )
            }}
        />
    )
}